// extracted by mini-css-extract-plugin
module.exports = {"item":"styles-module--item--3of6i","slider":"styles-module--slider--3XQXZ","wrap":"styles-module--wrap--3NnQv","sliderContainer":"styles-module--slider-container--1qRGF"};